// native
import { NgModule } from "@angular/core";

// module
import { SharedModule } from "../shared/shared.module";

// component
import { WorkItemsComponent } from './work-items.component';
import { WorkItemFilterFormComponent } from './work-item-filter-form/work-item-filter-form.component';
import { WorkItemDetailsComponent } from './work-item-details/work-item-details.component';
import { WorkItemsHistoryComponent } from './work-items-history/work-items-history.component';
import { DropDownListFilterComponent } from "./dropdown-list/dropdown-list-filter.component";

@NgModule({
  imports: [
    SharedModule
  ],
  declarations: [
    WorkItemsComponent,
    WorkItemFilterFormComponent,
    WorkItemDetailsComponent,
    WorkItemsHistoryComponent,
    DropDownListFilterComponent
  ]
})
export class WorkItemsModule { }
